import React from 'react';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-white text-gray-800 p-6 md:p-12">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
        <p className="text-sm text-gray-500 mb-8">Last updated: January 26, 2025</p>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3">1. Introduction</h2>
          <p className="mb-4">
            Unity Delivery Tracker ("we", "our", or "us") is committed to protecting your privacy. 
            This Privacy Policy explains how we collect, use, and safeguard your information when 
            you use our mobile application and web service.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3">2. Information We Collect</h2>
          <h3 className="font-medium mb-2">2.1 Information You Provide</h3>
          <ul className="list-disc pl-6 mb-4 space-y-1">
            <li>Account credentials (username and password)</li>
            <li>Driver information (name, truck number)</li>
            <li>Delivery notes and comments</li>
            <li>Photos of delivery orders</li>
          </ul>
          
          <h3 className="font-medium mb-2">2.2 Automatically Collected Information</h3>
          <ul className="list-disc pl-6 mb-4 space-y-1">
            <li>GPS location data (only during check-in/check-out)</li>
            <li>Timestamps of deliveries</li>
            <li>Device information for authentication</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3">3. How We Use Your Information</h2>
          <ul className="list-disc pl-6 mb-4 space-y-1">
            <li>To provide and maintain our delivery tracking service</li>
            <li>To verify delivery completions with photo documentation</li>
            <li>To track delivery locations for operational purposes</li>
            <li>To generate reports and analytics for administrators</li>
            <li>To improve our services</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3">4. Data Retention</h2>
          <ul className="list-disc pl-6 mb-4 space-y-1">
            <li>Driver delivery history: 36 days</li>
            <li>Administrative records: 2 years</li>
            <li>Account information: Until account deletion</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3">5. Data Sharing</h2>
          <p className="mb-4">
            We do not sell, trade, or rent your personal information to third parties. 
            Your data is only accessible to:
          </p>
          <ul className="list-disc pl-6 mb-4 space-y-1">
            <li>Authorized administrators within your organization</li>
            <li>Our secure cloud database provider (MongoDB Atlas)</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3">6. Data Security</h2>
          <p className="mb-4">
            We implement industry-standard security measures including:
          </p>
          <ul className="list-disc pl-6 mb-4 space-y-1">
            <li>Encrypted data transmission (HTTPS/TLS)</li>
            <li>Secure password hashing</li>
            <li>JWT-based authentication with 24-hour expiration</li>
            <li>Cloud database with access controls</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3">7. Your Rights</h2>
          <p className="mb-4">You have the right to:</p>
          <ul className="list-disc pl-6 mb-4 space-y-1">
            <li>Access your personal data</li>
            <li>Request correction of inaccurate data</li>
            <li>Request deletion of your data</li>
            <li>Opt-out of location tracking (note: this may affect service functionality)</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3">8. Location Data</h2>
          <p className="mb-4">
            Our app collects GPS location data only during delivery check-in and check-out 
            operations. This data is used to verify delivery locations and is stored with 
            each delivery record. Location tracking is not continuous and only occurs when 
            you explicitly perform check-in or check-out actions.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3">9. Children's Privacy</h2>
          <p className="mb-4">
            Our service is not intended for use by children under 18 years of age. 
            We do not knowingly collect personal information from children.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3">10. Changes to This Policy</h2>
          <p className="mb-4">
            We may update this Privacy Policy from time to time. We will notify you of 
            any changes by posting the new Privacy Policy on this page and updating the 
            "Last updated" date.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3">11. Contact Us</h2>
          <p className="mb-4">
            If you have any questions about this Privacy Policy, please contact us at:
          </p>
          <p className="font-medium">Unity Contractors Pte Ltd</p>
          <p>Singapore</p>
        </section>

        <div className="mt-12 pt-6 border-t border-gray-200">
          <a href="/" className="text-orange-500 hover:text-orange-600 font-medium">
            ← Back to App
          </a>
        </div>
      </div>
    </div>
  );
}
